import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=7f7ef038&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=7f7ef038&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7ef038",
  null
  
)

export default component.exports